<template>
    <mdb-row>
		<menu-item href="/monitoring" col="12">Monitoring</menu-item>
		<menu-item href="/graph" col="12">Graph</menu-item>
		<menu-item href="/bindings" col="12">Bindings</menu-item>
		<menu-item href="/parameters" col="12">Parameters</menu-item>
		<menu-item href="/rules" col="12">Rules</menu-item>
		<menu-item href="/lists" col="12">Lists</menu-item>
		<menu-item href="/dashboard" col="12">Dashboard</menu-item>
	</mdb-row>
</template>

<script>
import MenuItem from '@/components/common/MenuItem'

export default {
	name: 'Menu',
	components: { MenuItem }
}
</script>

<style scoped>
</style>
